import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MenuItem } from 'primeng/api';
import { saveAs } from 'file-saver';
import { GifcardVirtualService } from 'src/app/services/gifcardVirtual.service';
import { GiftCardVirtualsModel } from "src/app/models/gifcardVirtual.model";
import { AuthService } from 'src/app/services/auth.service';
import { TraceService } from 'src/app/services/trace.service';
var fnCloseDlg;

export interface itemTablaGrupo {
    grupo: number;
    cantidad: number;
    monto: number;
    subtotal: number;
}

@Component({
    selector: 'ordersales-step3',
    templateUrl: 'ordersales-step3.component.html'
})

export class OrderSalesStep3Component implements OnInit {

    validaUploadImages: boolean = true;

    id_order_sales: string;
    id_modelo_gift_card: string;
    id_cliente: string;
    id_contacto: string;

    begin_number: number;
    begin_sequence: number;
    id_assign_ncr: number;
    id_distr_ncr: number;
    url_fondo_gift_card: string;
    is_assign_group = true;
    id_template: number;
    id_type_ncr: number;
    nombre_modelo_gift_card: string;
    fileModelPath: string;
    email_contacto: string;
    isStep1Complete = false;
    isStep2Complete = false;
    isGroupActiveComplete = false;
    isSingleActiveComplete = false;
    orderSalesFormGroup: FormGroup;
    nroGrupo: number;
    itemOrderSales;


    constructor(private giftCardService: GifcardVirtualService,
        private messageService: MessageService,
        private authService: AuthService,
        private traceService: TraceService,
        private formBuilder: FormBuilder) {

    }

    displayDialog: boolean;
    itemGrupo: itemTablaGrupo = { grupo: 0, cantidad: 0, monto: 0.0, subtotal: 0.0 };
    selectGrupo: itemTablaGrupo;
    datasourceTablaGrupo: itemTablaGrupo[];
    colsTablaGrupo: any[];

    totalCantidad: number = 0;
    totalSubtotal: number = 0;
    botoneraStep2: MenuItem[];
    chkIncluirDatosAdicionales: boolean;

    msgTabla: string;
    idDisabledBtnAddGroup = false;
    isDisabledBtnAsignarGroup = true;
    isDisabledBtnAsignarSingle = true;
    isDisabledTabGroup = false;
    isDisabledTabSingle = false;

    displayDialog2: boolean;
    itemGiftCard: GiftCardVirtualsModel = {
        ID_GIFT_CARD: 0,
        ID_ORDER_GIFT_CARD: 0,
        ID_MODELO_GIFT_CARD: 0,
        NUMALE_GIFT_CARD: 0,
        PREFIX_GIFT_CARD: '',
        CODIGO_GIFT_CARD: '',
        BIN_GIFT_CARD: '',
        ID_GROUP: 0,
        ID_SECUENCE_NCR: 0,
        NOMBR_GIFT_CARD: '',
        MONTO_GIFT_CARD: 0,
        DOCUM_GIFT_CARD: '',
        TEXTO_GIFT_CARD: '',
        EMAIL_GIFT_CARD: '',
        VALID_TEXT_GIFT_CARD: '',
        STATUS_ENVIO: ''
    };
    selectGiftCard: GiftCardVirtualsModel;
    datasourceTablaGiftCardVirtual: GiftCardVirtualsModel[] = [];
    colsTablaGiftCard: any[];

    dlgUploadModel: boolean;
    dlgUploadOrder: boolean;

    currentUser: string;
    loading: boolean = false;

    ngOnInit() {
        this.currentUser = this.authService.getCurrentUser();
        this.createColumnsTablaGrupo();
    }

    createColumnsTablaGrupo() {
        this.colsTablaGrupo = [
            { field: 'grupo', header: 'Grupo' },
            { field: 'cantidad', header: 'Cantidad' },
            { field: 'monto', header: 'Monto' },
            { field: 'subtotal', header: 'Subtotal' }
        ];
    }

    createColumnsTablaGiftCardVirtual() {
        this.colsTablaGiftCard = [
            { field: 'TOTALCODE_GIFT_CARD', header: 'BIN Tarjeta' },
            { field: 'MONTO_GIFT_CARD', header: 'Monto' },
        ];
    }

    addGrupo() {
        if (this.nroGrupo != null && !isNaN(this.nroGrupo) && this.nroGrupo > 0) {
            this.datasourceTablaGrupo = [];
            for (let i = 0; i < this.nroGrupo; i++) {
                let item = { grupo: i + 1, cantidad: 0, monto: 0.00, subtotal: 0 };
                this.datasourceTablaGrupo.push(item);
                this.totalCantidad = 0;
                this.totalSubtotal = 0;
            }
            this.isDisabledBtnAsignarGroup = true;
        }
        else {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ingrese un número de grupo válido' });
        }
    }

    cloneItemGrupo(item: itemTablaGrupo): itemTablaGrupo {
        let grupo = {};
        for (let prop in item) {
            grupo[prop] = item[prop];
        }
        return item;
    }

    cloneGiftCard(item: GiftCardVirtualsModel): GiftCardVirtualsModel {
        let giftcard = {};
        for (let prop in item) {
            giftcard[prop] = item[prop];
        }
        return item;
    }

    onTabChange(event) {
        this.totalCantidad = 0;
        this.totalSubtotal = 0;
        this.msgTabla = "";
        this.is_assign_group = true;
        this.datasourceTablaGrupo = [];
        this.nroGrupo = null;

        if (event.index == 1) {
            this.is_assign_group = false;
            this.createColumnsTablaGiftCardVirtual();
            this.populateTablaGiftCardVirtual();
        }
    }

    onRowSelect(event) {
        this.itemGrupo = this.cloneItemGrupo(event.data);
        this.displayDialog = true;
    }

    onRowSelectGiftCard(event) {
        this.itemGiftCard = this.cloneGiftCard(event.data);
        this.displayDialog2 = true;
    }

    updateGrupo() {
        if (this.itemGrupo.cantidad == null || isNaN(this.itemGrupo.cantidad) || this.itemGrupo.cantidad == 0) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ingrese una cantidad válida' });
        }
        else if (this.itemGrupo.monto == null || isNaN(this.itemGrupo.monto) || this.itemGrupo.monto == 0) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ingrese un monto válido' });
        }
        else {
            let tmp = [...this.datasourceTablaGrupo];
            this.itemGrupo.subtotal = this.itemGrupo.cantidad * this.itemGrupo.monto;
            tmp[this.datasourceTablaGrupo.indexOf(this.selectGrupo)] = this.itemGrupo;
            this.datasourceTablaGrupo = tmp;
            this.itemGrupo = null;
            this.displayDialog = false;
            this.calculateGrupoTotales();
        }
    }

    updateGiftCard() {
        if (this.itemGiftCard.MONTO_GIFT_CARD == null || isNaN(this.itemGiftCard.MONTO_GIFT_CARD) || this.itemGiftCard.MONTO_GIFT_CARD == 0) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ingrese un monto válido' });
        }
        else {
            let tmp = [...this.datasourceTablaGiftCardVirtual];
            tmp[this.datasourceTablaGiftCardVirtual.indexOf(this.selectGiftCard)] = this.itemGiftCard;
            this.datasourceTablaGiftCardVirtual = tmp;
            this.itemGiftCard = null;
            this.displayDialog2 = false;
            this.calculateGiftCardTotal();
        }
    }

    calculateGrupoTotales() {
        this.totalCantidad = 0;
        this.totalSubtotal = 0;
        for (let i = 0; i < this.datasourceTablaGrupo.length; i++) {
            if (this.datasourceTablaGrupo[i].cantidad > 0 && this.datasourceTablaGrupo[i].subtotal > 0) {
                this.totalCantidad += Number(this.datasourceTablaGrupo[i].cantidad);
                this.totalSubtotal += Number(this.datasourceTablaGrupo[i].subtotal);
            }
        }

        if (this.totalCantidad == Number(this.itemOrderSales.CAN_ORDEN_COMPRA) &&
            this.totalSubtotal == Number(this.itemOrderSales.IMP_ORDEN_COMPRA)) {
            this.msgTabla = 'La cantidad y el importe total son correctos';
            this.messageService.add({ severity: 'info', summary: 'Mensaje', detail: this.msgTabla });
            this.isDisabledBtnAsignarGroup = false;
        }
        else {
            this.msgTabla = 'La cantidad o el importe total son diferentes a los valores de la orden de compra';
            this.messageService.add({ severity: 'error', summary: 'Error', detail: this.msgTabla });
            this.isDisabledBtnAsignarGroup = true;
        }
    }

    calculateGiftCardTotal() {
        this.totalSubtotal = 0;
        let giftInZero: boolean = false;
        for (let i = 0; i < this.datasourceTablaGiftCardVirtual.length; i++) {
            if (this.datasourceTablaGiftCardVirtual[i].MONTO_GIFT_CARD > 0) {
                this.totalSubtotal += Number(this.datasourceTablaGiftCardVirtual[i].MONTO_GIFT_CARD);
            }
        }
        this.datasourceTablaGiftCardVirtual.forEach(group => {
            if (group.MONTO_GIFT_CARD == 0) {
                giftInZero = true;
                return;
            }
        })

        if (giftInZero) {
            this.msgTabla = 'Existen gift card con monto CERO';
            this.messageService.add({ severity: 'error', summary: 'Error', detail: this.msgTabla });
            this.isDisabledBtnAsignarSingle = true;
            return;
        }

        if (this.totalSubtotal == Number(this.itemOrderSales.IMP_ORDEN_COMPRA)) {
            this.msgTabla = 'El importe total es correcto.';
            this.messageService.add({ severity: 'info', summary: 'Mensaje', detail: this.msgTabla });
            this.isDisabledBtnAsignarSingle = false;
        }
        else {
            this.msgTabla = 'El importe total es diferente al importe de la orden de compra';
            this.messageService.add({ severity: 'error', summary: 'Error', detail: this.msgTabla });
            this.isDisabledBtnAsignarSingle = true;
        }
    }

    onClickActiveGroup() {
        this.loading = true;
        this.createGroupGiftCard();
    }

    onClickActiveSingle() {
        this.loading = true;
        if (this.datasourceTablaGiftCardVirtual) {
            for (let i = 0; i < this.datasourceTablaGiftCardVirtual.length; i++) {
                let giftCard = {
                    "p_id_gift_card": this.datasourceTablaGiftCardVirtual[i].ID_GIFT_CARD,
                    "p_id_order_gift_card": this.id_order_sales,
                    "p_id_modelo_gift_card": this.id_modelo_gift_card,
                    "p_id_cliente_gift_card": this.id_cliente,
                    "p_id_contact_gift_card": this.id_contacto,
                    "p_monto_gift_card": this.datasourceTablaGiftCardVirtual[i].MONTO_GIFT_CARD
                };
                this.giftCardService.UpdateGiftCardBySingle(giftCard).subscribe(
                    (response) => {
                        if ((i + 1) == this.datasourceTablaGiftCardVirtual.length) {
                            this.sendNCR();
                            this.msgTabla = '';
                        }
                    },
                    (error) => {
                        this.isStep2Complete = false;
                        this.isDisabledTabGroup = false;
                        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al realizar la asignación individual.' });
                    }
                )
            }
        }
    }

    createGroupGiftCard() {
        if (this.datasourceTablaGrupo != null && this.datasourceTablaGrupo.length > 0) {
            for (let i = 0; i < this.datasourceTablaGrupo.length; i++) {
                if (this.datasourceTablaGrupo[i].cantidad > 0 && this.datasourceTablaGrupo[i].subtotal > 0) {
                    let item = {
                        "p_id_order_gift_card": this.id_order_sales,
                        "p_id_modelo_gift_card": this.id_modelo_gift_card,
                        "p_id_cliente_gift_card": this.id_cliente,
                        "p_id_contact_gift_card": this.id_contacto,
                        "p_imp_order_gift_card": this.itemOrderSales.CAN_ORDEN_COMPRA,
                        "p_can_order_gift_card": this.itemOrderSales.IMP_ORDEN_COMPRA,
                        "p_nro_group": this.datasourceTablaGrupo[i].grupo,
                        "p_imp_group": this.datasourceTablaGrupo[i].monto,
                        "p_can_group": this.datasourceTablaGrupo[i].cantidad,
                        "p_creationuser": this.currentUser
                    };
                    this.giftCardService.GroupActive(item).subscribe(
                        (response) => {
                            if ((i + 1) == this.datasourceTablaGrupo.length) {
                                this.updateGiftCardByGroup();
                            }
                        },
                        (error) => {
                            this.loading = false;
                            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al realizar la asignación grupal.' });
                        }
                    )
                }
            }
            this.msgTabla = '';
        }
        else {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Debe ingresar al menos un grupo válido.' });
        }

    }

    updateGiftCardByGroup() {
        let group = {
            "p_id_order_gift_card": this.id_order_sales,
            "p_id_modelo_gift_card": this.id_modelo_gift_card,
            "p_id_cliente_gift_card": this.id_cliente,
            "p_id_contact_gift_card": this.id_contacto,
        };
        this.giftCardService.UpdateGiftCardByGroup(group).subscribe(
            (response) => {
                this.isGroupActiveComplete = true;
                this.idDisabledBtnAddGroup = true;
                this.isDisabledBtnAsignarGroup = true;
                this.isDisabledTabSingle = true;
                this.listTablaGiftCardVirtual();
                this.sendNCR();
            },
            (error) => {
                this.loading = false;
                this.isGroupActiveComplete = false;
                this.idDisabledBtnAddGroup = false;
                this.isDisabledBtnAsignarGroup = false;
                this.isDisabledTabSingle = false;
                this.isStep2Complete = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al actualizar gift card por grupo.' });
            }
        )
    }

    sendNCR() {
        this.createAsignationnNCR();
        this.createOrderSalesTrace('DISTRIBUIDO');
        //this.updateOrderSalesStatus(8);
    }

    populateTablaGiftCardVirtual() {
        this.loading = true;
        let order = {
            "p_id_order_gift_card": this.id_order_sales,
            "p_id_modelo_gift_card": this.id_modelo_gift_card,
            "p_id_cliente_gift_card": this.id_cliente,
            "p_id_contact_gift_card": this.id_contacto
        };
        this.giftCardService.GetGiftCardVirtuals(order).subscribe(
            (response: GiftCardVirtualsModel[]) => {
                this.datasourceTablaGiftCardVirtual = response;
                this.totalCantidad = this.datasourceTablaGiftCardVirtual.length;
                this.loading = false;
            },
            (error) => {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al listar gift card.' });
            }
        )
    }

    listTablaGiftCardVirtual() {
        let order = {
            "p_id_order_gift_card": this.id_order_sales,
            "p_id_modelo_gift_card": this.id_modelo_gift_card,
            "p_id_cliente_gift_card": this.id_cliente,
            "p_id_contact_gift_card": this.id_contacto
        };
        this.giftCardService.GetGiftCardVirtuals(order).subscribe(
            (response: GiftCardVirtualsModel[]) => {
                this.datasourceTablaGiftCardVirtual = response;
            },
            (error) => {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al listar gift card.' });
            }
        )
    }

    showDlgUploadModel() {
        this.dlgUploadModel = true;
    }

    showDlgUploadOrder() {
        this.dlgUploadOrder = true;
    }

    onCloseDlgDistribution() {
        fnCloseDlg();
    }

    public loadParametersOrderSalesStep3(orderValues, funcionClose) {
        this.itemOrderSales = orderValues;
        this.id_order_sales = orderValues.ID_ORDER_SALES;
        this.id_modelo_gift_card = orderValues.ID_MODELO_GIFT_CARD;
        this.id_type_ncr = orderValues.ID_TYPES_NCR,
            this.id_cliente = orderValues.ID_CLIENTE;
        this.id_contacto = orderValues.ID_CONTACT;
        this.begin_number = orderValues.BEGIN_NUMBER;
        fnCloseDlg = funcionClose;
    }

    createAsignationnNCR() {
        let params = {
            "p_type": this.id_type_ncr,
            "p_qty": this.totalCantidad,
            "p_begin_number": this.begin_number
        };
        this.giftCardService.CreateGiftCardAssignationNCR(params).subscribe(
            (response) => {
                let json = response;
                this.begin_sequence = json.p_out_begin_sequence;
                this.id_assign_ncr = json.p_out_id_assign;
                this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Distribución paso 1: exitoso.' });
                this.createDistributionNCR();
                console.log("Secuencial NCR:" + this.begin_sequence);
            },
            (error) => {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al crear asignación de giftcard.' });
            }
        );
    }

    createDistributionNCR() {
        let params = {
            "p_type": this.id_type_ncr,
            "p_branch": 999,
            "p_qty": this.totalCantidad,
            "p_begin_number": this.begin_number,
            "p_begin_sequence": this.begin_sequence
        };
        this.giftCardService.CreateGiftCardDistributionNCR(params).subscribe(
            (response) => {
                let json = response;
                this.id_distr_ncr = json.p_out_id_dist;
                this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Distribución paso 2: exitoso.' });
                this.createGiftCardNCR();
            },
            (error) => {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al crear distribución de giftcard.' });
            }
        );
    }

    createGiftCardNCR() {
        console.log("Create Giftcard NCR Begin Sequence: "+ this.begin_sequence);
        let sequence: number = this.begin_sequence;
        let assigIdx: number = 0;
        let distrIdx: number = 0;

        let params = [];
        for (let i = 0; i < this.datasourceTablaGiftCardVirtual.length; i++) {   
            params.push({
                "p_number": this.datasourceTablaGiftCardVirtual[i].BIN_GIFT_CARD,
                "p_sequence": sequence,
                "p_status": 'DI',
                "p_branchId": 999,
                "p_netAmount": this.datasourceTablaGiftCardVirtual[i].MONTO_GIFT_CARD,
                "p_assignationBatch": this.id_assign_ncr,
                "p_distributionBatch": this.id_distr_ncr,
                "p_assignationBatchIdx": assigIdx,
                "p_distributionBatchIdx": distrIdx
            });
            
            sequence++;
            assigIdx++;
            distrIdx++;
        }

        this.giftCardService.CreateGiftCardVirtualNCRMassive(params).subscribe((response) => {
                console.log("Resp CreateGiftCardVirtualNCRMassive: " + response);
                this.updateOrderSalesStatus(8);
                this.updateOrderSalesDistribution();
                this.isStep2Complete = true;
                this.loading = false;
                this.isDisabledBtnAsignarSingle = true;
                this.isDisabledTabGroup = true;
                this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'La distribución se realizo correctamente.' });
            }, (error) => {
                console.log("Error CreateGiftCardVirtualNCRMassive: " + error);
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al crear giftcard en NCR.' });
            }
        );
    }

    createOrderSalesTrace(status: string) {
        let params = {
            "p_id_order_gift_card": this.itemOrderSales.ID_ORDER_SALES,
            "p_id_modelo_gift_card": this.itemOrderSales.ID_MODELO_GIFT_CARD,
            "p_id_cliente_gift_card": this.itemOrderSales.ID_CLIENTE,
            "p_id_contact_gift_card": this.itemOrderSales.ID_CONTACT,
            "p_type_order_sales": 'V',
            "p_action": status,
            "p_observation": 'Distribución exitosa.',
            "p_creationuser": this.currentUser
        };
        this.traceService.CreateGiftCardOrderSalesTrace(params).subscribe(
            (response) => {
                this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Trace registrado correctamente.' });
            },
            (error) => {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al crear el trace de la orden de compra' });
            }
        )
    }

    updateOrderSalesStatus(flg_activo: number) {
        let params = {
            "p_id_order_gift_card": this.itemOrderSales.ID_ORDER_SALES,
            "p_id_modelo_gift_card": this.itemOrderSales.ID_MODELO_GIFT_CARD,
            "p_id_cliente_gift_card": this.itemOrderSales.ID_CLIENTE,
            "p_id_contact_gift_card": this.itemOrderSales.ID_CONTACT,
            "p_flg_activo": flg_activo
        }
        this.giftCardService.UpdateOrderSalesStatus(params).subscribe(
            (response) => {
                this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Actualización del estado de la orden de compra: exitoso.' });
            },
            (error) => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al actualizar el estado de la orden de compra.' });
            }
        )
    }

    updateOrderSalesDistribution() {
        let params = {
            "p_id_order_gift_card": this.itemOrderSales.ID_ORDER_SALES,
            "p_id_modelo_gift_card": this.itemOrderSales.ID_MODELO_GIFT_CARD,
            "p_id_cliente_gift_card": this.itemOrderSales.ID_CLIENTE,
            "p_id_contact_gift_card": this.itemOrderSales.ID_CONTACT,
            "p_id_assign_ncr": this.id_assign_ncr,
            "p_id_distr_ncr": this.id_distr_ncr,
            "p_begin_sequence": this.begin_sequence
        }
        console.log("UpdateOrderSalesDistribution: " + JSON.stringify(params));
        this.giftCardService.UpdateOrderSalesDistribution(params).subscribe((response) => {
            console.log("Resp UpdateOrderSalesDistribution: " + response);
            },
            (error) => {
                console.log("Error UpdateOrderSalesDistribution: " + error);
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al actualizar el estado de la orden de compra.' });
            }
        )
    }

    downloadIMGModel() {
        saveAs(this.itemOrderSales.IMG_MODELO_GIFT_CARD, "modelo.jpg");
    }

    downloadIMGOrder() {
        saveAs(this.itemOrderSales.IMG_ORDEN_COMPRA, "orden.jpg");
    }

    downloadIMGCotizacion() {
        saveAs(this.itemOrderSales.IMG_COTIZACION, "cotizacion.jpg");
    }

    donwloadAdicional1() {
        saveAs(this.itemOrderSales.IMG_ADICIONAL1, "adicional.jpg");
    }

    donwloadAdicional2() {
        saveAs(this.itemOrderSales.IMG_ADICIONAL2, "adiciona2.jpg");
    }

    donwloadAdicional3() {
        saveAs(this.itemOrderSales.IMG_ADICIONAL3, "adiciona3.jpg");
    }
}